import moment from 'moment'
import { useCallback, useMemo } from 'react'

import { DateChangeButton } from 'components/common'
import { DEFAULT_SELECTABLE_PAST_DAYS_RANGE, DEFAULT_SELECTABLE_FUTURE_DAYS_RANGE } from 'components/common/constants'

import useDateChange from 'hooks/useDateChange'
import useDateQuery from 'hooks/useDateQuery'

type Props = {
  onChange: (date: string) => void
}
const DashboardDateChangeButton = ({ onChange }: Props) => {
  const date = useDateQuery()
  const { createDateFilter } = useDateChange()

  const filterDate = useMemo(
    () =>
      createDateFilter({ fromDays: -DEFAULT_SELECTABLE_PAST_DAYS_RANGE, toDays: DEFAULT_SELECTABLE_FUTURE_DAYS_RANGE }),
    [createDateFilter]
  )

  const onChangeDate = useCallback((newDate: Date) => onChange(moment(newDate).format('YYYY-MM-DD')), [onChange])

  return (
    <div>
      <DateChangeButton date={date} popupPosition="bottom right" filterDate={filterDate} onChange={onChangeDate} />
    </div>
  )
}
export default DashboardDateChangeButton
